import { startsWith } from 'lodash';

const phoneUnification = (value) => {
  let phone = value;
  if (phone && !startsWith(phone, '+1')) {
    phone = `+1${value}`;
  }
  return phone;
};


export default phoneUnification;
